import { caseService } from "../_services";
import moment from 'moment'
moment.locale('ru')

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,


  state: {
    baseCases: {
      list: [],
      status: status.INITIAL
    },

    baseCasesOffice: {
      list: [],
      status: status.INITIAL
    },

    baseCasesArchive: {
      list: [],
      status: status.INITIAL
    },
    statuses: {
      list: [],
      status: status.INITIAL
    },
    caseTableTypes: {
      list: [],
      status: status.INITIAL
    },
    selectedStatus: null,
    selectedSort: 0,

    period: null,

    history: []
  },

  getters: {
    statuses: ({ statuses }) => statuses.list.sort((a, b) => a.color - b.color),
    isStatusesLoaded: ({ statuses }) => statuses.status == status.LOADED,

    caseTableTypes: ({ caseTableTypes }) => caseTableTypes.list.sort((a, b) => a.value - b.value),
    isCaseTableTypes: ({ caseTableTypes }) => caseTableTypes.status == status.LOADED,

    baseCases: ({ baseCases }) => baseCases.list.map(item => {
      let list = item.memberNames.map(name => name.toLowerCase())
      item.searchlist = [item.number.toLowerCase(), ...list]
      return item
    }),
    isBaseCasesLoaded: ({ baseCases }) => baseCases.status == status.LOADED,

    history ({ history }) {
      var arr = [...history]
      return arr.reverse().slice(0, 15)
    }
  },

  mutations: {
    setBaseCases: ({ baseCases }, payload) => {
        baseCases.list = payload
    },
    setBaseCasesStatus: ({ baseCases }, status) => {
        baseCases.status = status
    },

    setBaseCasesOffice: (state, payload) => {
      state.baseCasesOffice.list = payload
      state.baseCases.list = [...state.baseCases.list, ...state.baseCasesOffice.list]
    },
    setBaseCasesOfficeStatus: ({ baseCasesOffice }, status) => {
      baseCasesOffice.status = status
    },

    setBaseCasesArchive: (state , payload) => {
      state.baseCasesArchive.list = payload
      state.baseCases.list = [...state.baseCases.list, ...state.baseCasesArchive.list]
    },
    setBaseCasesArchiveStatus: ({ baseCasesArchive }, status) => {
      baseCasesArchive.status = status
    },

    addCaseInCases: (state, c) => {
      state.baseCases.list.push(c)
    },

    setStatuses: ({ statuses }, payload) => {
        statuses.list = payload
    },
    setStatusesStatus: ({ statuses }, status) => {
        statuses.status = status
    },
    selectStatus: (state, payload) => {
      state.selectedStatus = payload
    },

    setCaseTableTypes: ({ caseTableTypes }, payload) => {
      caseTableTypes.list = payload
    },
    setCaseTableTypesStatus: ({ caseTableTypes }, status) => {
      caseTableTypes.status = status
    },

    selectSort: (state, payload) => {
      state.selectedSort = payload
    },

    setPeriod: (state, payload) => {
      state.period = payload
    },

    addCaseToHistory: (state, payload) => {
      state.history = state.history.filter(c => c.id != payload.id)
      state.history.push({ ...payload })
    }
  },
  
  actions: {
    INIT: ({ dispatch }, { limitView }) => {
        dispatch('GET_STATUSES')
        dispatch('GET_CASE_TABLE_TYPES')
        dispatch('LOAD_COURT_CASES', limitView)
      },
    GET_STATUSES: ({ state, commit }) => {
      if (state.statuses.status == status.INITIAL) {
        commit('setStatusesStatus', status.LOADING)
        caseService.caseStatuses().then(data => {
          commit('setStatuses', data)
          commit('setStatusesStatus', status.LOADED)
        })
      }
    },
    GET_CASE_TABLE_TYPES: ({ state, commit }) => {
      if (state.caseTableTypes.status == status.INITIAL) {
        commit('setCaseTableTypesStatus', status.LOADING)
        caseService.caseTableTypes().then(data => {
          commit('setCaseTableTypes', data)
          commit('setCaseTableTypesStatus', status.LOADED)
        })
      }
    },
    LOAD_COURT_CASES: ({ state, commit }, limitView ) => {
      if (state.baseCases.status == status.INITIAL) {
        commit('setBaseCasesStatus', status.LOADING)
        if(limitView) {
          caseService.listWithEventdate().then(data => {
              commit('setBaseCases', data)
              commit('setBaseCasesStatus', status.LOADED)
          }).catch(error => {
            if (error.response.status == 500) {
              commit('setBaseCases', [])
              commit('setBaseCasesStatus', status.LOADED)
            }
          })
        } else {
          caseService.list().then(data => {
              commit('setBaseCases', data)
              commit('setBaseCasesStatus', status.LOADED)
          }).catch(error => {
            if (error.response.status == 500) {
              commit('setBaseCases', [])
              commit('setBaseCasesStatus', status.LOADED)
            }
          })
        }
      }
    },

    LOAD_CASE_BY_STATUS_OFFICE: ({ state, commit }, statusCourtCase) => {
      if (state.baseCasesOffice.status == status.INITIAL) {
        commit('setBaseCasesOfficeStatus', status.LOADING)
        commit('setBaseCasesStatus', status.LOADING)
        caseService.listByStatus(statusCourtCase).then(data => {
          commit('setBaseCasesOffice', data)
          commit('setBaseCasesOfficeStatus', status.LOADED)
          commit('setBaseCasesStatus', status.LOADED)
        }).catch(error => {
          if (error.response !== undefined && error.response.status == 500) {
            commit('setBaseCasesOffice', [])
            commit('setBaseCasesOfficeStatus', status.LOADED)
            commit('setBaseCasesStatus', status.LOADED)
          }
        })
      }
    },

    LOAD_CASE_BY_STATUS_ARCHIVE: ({ state, commit }, statusCourtCase) => {
      if (state.baseCasesArchive.status == status.INITIAL) {
        commit('setBaseCasesArchiveStatus', status.LOADING)
        commit('setBaseCasesStatus', status.LOADING)
        caseService.listByStatus(statusCourtCase).then(data => {
          commit('setBaseCasesArchive', data)
          commit('setBaseCasesArchiveStatus', status.LOADED)
          commit('setBaseCasesStatus', status.LOADED)
        }).catch(error => {
          if (error.response !== undefined && error.response.status == 500) {
            commit('setBaseCasesArchive', [])
            commit('setBaseCasesArchiveStatus', status.LOADED)
            commit('setBaseCasesStatus', status.LOADED)
          }
        })
      }
    },
  }
}